module.exports = __webpack_public_path__ + "img/NissanLeafMotor3.a9fb4702.jpeg";